/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FunctionComponent } from "react";

export enum PANEL_STYLE {
	NONE = "none",
	BASE = "base",
	PRIMARY = "primary"
}

/**
 * Component props
 */
export interface IPanelProps {
	style?: PANEL_STYLE;
	scroll?: boolean;
	className?: string;
	mark?: string;
	pending?: boolean;
}

/**
 * Panel component
 */
export const Panel: FunctionComponent<IPanelProps> = ({
	children,
	style,
	scroll,
	className,
	mark,
	pending
}) => {
	const baseClass = BEM("edt-panel", null, {
		scroll: scroll,
		style: style || PANEL_STYLE.NONE,
		pending
	}).add("edt-base");

	if (className) {
		baseClass.add(className);
	}

	if (mark) {
		baseClass.add("m-" + mark);
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};

/**
 * Component props
 */
export interface IPanelNoteProps {
	align?: "left" | "center" | "right";
}

/**
 * Panel component
 */
export const PanelNote: FunctionComponent<IPanelNoteProps> = ({ children, align }) => {
	const baseClass = BEM("edt-panel", "note", { align });

	return <div className={baseClass.toClassName()}>{children}</div>;
};

PanelNote.defaultProps = {
	align: "left"
};
